import React from "react";

// Thin double-line gold corner brackets (top-left + bottom-right), echoing the
// brochure's certificate-style page frame. Place inside a `relative` container.
export function CornerFrame({
  inset = "inset-4 sm:inset-6",
  z = "z-20",
}: {
  inset?: string;
  z?: string;
}) {
  return (
    <div className={`pointer-events-none absolute ${inset} ${z}`} aria-hidden="true">
      <div className="absolute top-0 left-0 w-10 sm:w-14 h-10 sm:h-14 border-t border-l border-gold" />
      <div className="absolute top-1.5 left-1.5 w-7 sm:w-10 h-7 sm:h-10 border-t border-l border-gold/50" />
      <div className="absolute bottom-0 right-0 w-10 sm:w-14 h-10 sm:h-14 border-b border-r border-gold" />
      <div className="absolute bottom-1.5 right-1.5 w-7 sm:w-10 h-7 sm:h-10 border-b border-r border-gold/50" />
    </div>
  );
}

// Thin gold rule flanking a small rotated-square ornament, used under headlines
// the same way the brochure separates a title from its subtitle.
export function GoldDivider({
  className = "my-6",
  toneClassName = "bg-gold",
}: {
  className?: string;
  toneClassName?: string;
}) {
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
      <span className={`h-px w-10 ${toneClassName}`} />
      <span className={`w-1.5 h-1.5 rotate-45 shrink-0 ${toneClassName}`} />
      <span className={`h-px w-10 ${toneClassName}`} />
    </div>
  );
}
